import { useEffect, useState } from "react";
import React from "react";
import styles from "./Page.module.scss";

export default function Page({ children, pageNumber, currentPage }) {
  const [isCurrentPage, setIsCurrentPage] = useState(false);
  const [showCurrentPage, setShowCurrentPage] = useState(false);

  useEffect(() => {
    setIsCurrentPage(() => pageNumber === currentPage);
  }, [currentPage, pageNumber]);

  useEffect(() => {
    if (isCurrentPage) {
      setTimeout(() => {
        setShowCurrentPage(true);
      }, 1);
    } else {
      setShowCurrentPage(false);
    }
  }, [isCurrentPage]);

  return (
    <div
      className={`${styles.page} ${
        isCurrentPage ? styles.displayCurrent : ""
      } ${showCurrentPage ? styles.current : styles.hidden}`}
    >
      {children}
    </div>
  );
}
